// @mui
import { enUS } from '@mui/material/locale';
// components
import { SettingsValueProps } from './components/settings/type';

// API
// ----------------------------------------------------------------------

export const getHostApi = (): string => {
  const devUrl = (process.env.REACT_APP_DEV_API_URL || 'https://dev-admin-api.electionsetu.com').replace(/\/$/, '');
  const prodUrl = (process.env.REACT_APP_API_URL || 'https://admin-api.electionsetu.com').replace(/\/$/, '');

  // 1. Explicit environment override in .env
  if (process.env.REACT_APP_ENV === 'development') {
    return devUrl;
  }
  if (process.env.REACT_APP_ENV === 'production') {
    return prodUrl;
  }

  // 2. Development server (yarn dev / react-scripts start)
  if (process.env.NODE_ENV === 'development') {
    return devUrl;
  }

  // 3. Runtime browser detection (works even after yarn build):
  // If running on localhost, dev server domain, staging or ngrok, use DEV API.
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname.toLowerCase();
    const isDevHost =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host.includes('dev') ||
      host.includes('staging') ||
      host.includes('ngrok') ||
      host.includes('preview');

    if (isDevHost) {
      return devUrl;
    }
  }

  // 4. Production domain default (e.g. admin.electionsetu.com)
  return prodUrl;
};

export const HOST_API = getHostApi();



// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 38,
  DASHBOARD_ITEM_SUB_HEIGHT: 34,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
  themeFontFamily: 'Public Sans',
  themeFontSize: 16,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_in.svg',
  },
];

export const defaultLang = allLangs[0]; // English
